<script setup lang="ts">
import type { VStatusChipProps } from "./VStatusChip.types";
import { computed } from "vue";
import { statusChipCva, statusChipDotCva } from "./VStatusChip.cva";

defineOptions({
  name: "VStatusChip",
});

const {
  tone = "neutral",
  label = "",
  dot = false,
  pulse = false,
  size = "sm",
} = defineProps<VStatusChipProps>();

defineSlots<{
  default?: () => unknown
}>();

const chipClass = computed(() => statusChipCva({ tone, size }));
const dotClass = computed(() => statusChipDotCva({ tone, pulse }));
</script>

<template>
  <span :class="chipClass" :data-tone="tone">
    <span v-if="dot" :class="dotClass" aria-hidden="true" />
    <slot>{{ label }}</slot>
  </span>
</template>

<style scoped>
/* The canvas "animate dots" motion: the dot breathes between 35% and full opacity. */
@keyframes status-chip-dot-flow {
  0%,
  100% {
    opacity: 0.35;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.25);
  }
}

.status-chip-dot--pulse {
  animation: status-chip-dot-flow 1.2s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .status-chip-dot--pulse {
    animation: none;
  }
}
</style>
